import { render, staticRenderFns } from "./laboratories.vue?vue&type=template&id=19f14b12"
import script from "./laboratories.vue?vue&type=script&lang=js"
export * from "./laboratories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports